import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from '../components/animations/FadeIn';
import SafeIcon from '../common/SafeIcon';
import { WaveGraphic } from '../components/graphics/WaveGraphic';

const Contact = () => {
  const contactEmail = "contact@sussexendocrineclinic.co.uk";

  return (
    <div className="min-h-screen bg-paper pt-32 pb-20 overflow-hidden relative">
      <WaveGraphic className="top-0 right-0 opacity-20 rotate-180" />
      
      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <FadeIn className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-semibold tracking-tight text-ink mb-6">
            Get in touch
          </h1>
          <p className="text-xl text-ink/60 font-light max-w-2xl mx-auto">
            For clinics, practitioners, or partnership inquiries regarding the Curve platform.
          </p>
        </FadeIn>

        <FadeIn delay={0.2}>
          <div className="bg-white rounded-[40px] shadow-soft p-8 md:p-16 border border-gray-100 flex flex-col items-center text-center">
            
            {/* Displaying Logo as the featured email visual */}
            <div className="w-28 h-28 rounded-[2rem] bg-ink flex items-center justify-center mb-8 relative group overflow-hidden shadow-xl border-4 border-white">
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1781865268786-image.png" 
                alt="Curve App Logo" 
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </div>

            <h2 className="text-2xl font-semibold text-ink mb-4">Direct Inquiries</h2>
            <p className="text-ink/60 font-light mb-8 max-w-sm">
              Our clinical relations team is ready to discuss how Curve can support your patients' GLP-1 journey.
            </p>

            <a 
              href={`mailto:${contactEmail}`}
              className="group relative inline-flex items-center gap-3 bg-ink text-white px-8 py-4 rounded-full font-semibold text-lg transition-all hover:bg-gray-800 hover:shadow-glow"
            >
              <span>{contactEmail}</span>
              <SafeIcon name="ArrowRight" className="group-hover:translate-x-1 transition-transform" />
            </a>
            
            <div className="mt-12 pt-12 border-t border-gray-100 w-full grid sm:grid-cols-2 gap-8 text-left">
              <div>
                <h4 className="font-semibold text-ink mb-2">Clinical Partnerships</h4>
                <p className="text-sm text-ink/60 font-light">Custom implementation and patient monitoring solutions for weight management clinics.</p>
              </div>
              <div>
                <h4 className="font-semibold text-ink mb-2">General Support</h4>
                <p className="text-sm text-ink/60 font-light">Feedback, media inquiries, or technical support for the Curve companion app.</p>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="mt-12 text-center text-ink/40 text-sm font-light">
          Sussex Endocrine Clinic &bull; United Kingdom
        </FadeIn>
      </div>
    </div>
  );
};

export default Contact;